import {
    Table,
    TableBody,
    TableCell,
    TableHeader,
    TableRow,
} from "@components/shadcn-ui/table";
import { useDynamicHeight } from "@customHooks/useDynamicHeight";
import { Badge } from "@components/shadcn-ui/badge";
import { Task, TaskStatus } from "../types";
import { Button } from "@components/shadcn-ui/button";
import { Eye } from "lucide-react";
import { useNavigate } from "react-router-dom";

const getStatusColor = (status: TaskStatus): string => {
    const colorMap: Record<TaskStatus, string> = {
        OPEN: "bg-blue-200 text-blue-900",
        IN_PROGRESS: "bg-yellow-200 text-yellow-900",
        COMPLETE: "bg-green-200 text-green-900",
        CANCELLED: "bg-red-200 text-red-900",
    };
    return colorMap[status];
};

export const TaskList = ({ tasks }: { tasks: Task[] }) => {
    const { ref, height } = useDynamicHeight();
    const navigate = useNavigate();

    return (
        <div className="overflow-auto" ref={ref} style={{ height: `${height}px` }}>
            <Table>
                <TableHeader className="bg-blue-200">
                    <TableRow>
                        <TableCell>Resource Id</TableCell>
                        <TableCell>Title</TableCell>
                        <TableCell>Task Type</TableCell>
                        <TableCell>Status</TableCell>
                        <TableCell>Due Date</TableCell>
                        <TableCell>Priority</TableCell>
                        <TableCell>Actions</TableCell>
                    </TableRow>
                </TableHeader>
                <TableBody>
                    {tasks.map((task) => (
                        <TableRow key={task.resourceId} className="bg-white h-[45px]">
                            <TableCell className="py-1">{task.resourceId}</TableCell>
                            <TableCell className="py-1 max-w-[200px] truncate">{task.title}</TableCell>
                            <TableCell className="py-1">{task.type}</TableCell>
                            <TableCell className="py-1">
                                <Badge className={`rounded-sm px-1 font-normal ${getStatusColor(task.status)}`}>
                                    {task.status.replace('_', ' ')}
                                </Badge>
                            </TableCell>
                            <TableCell className="py-1">
                                {new Date(task.dueDateInUTCEpoch).toLocaleDateString()}
                            </TableCell>
                            <TableCell className="py-1">{task.priority}</TableCell>
                            <TableCell className="py-1">
                                <Button
                                    variant="ghost"
                                    size="sm"
                                    onClick={() => navigate(`/dashboard/application/details/${task.resourceId}/tasks/${task.taskId}`)}
                                >
                                    <Eye className="h-4 w-4 mr-2" />
                                    View
                                </Button>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </div>
    );
};